import {Integer} from 'platform/foundation';

export const SIDEBAR_MOBILE_ICON_SIZE: Integer = 5;
